<script>
import { Search } from "lucide-vue-next";
import { Input } from "@/shared/ui/input";
import TableFooterWrapper from "@/shared/ui/custom/components/TableFooterWrapper.vue";
import dateFormat from "@/shared/lib/date-format";
import {
  getTariffPreferentialList,
  removeTariffPreferential,
} from "@/entities/tariff";
import { getReferenceListByCodes } from "@/entities/directory";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import Button from "@/shared/ui/button/Button.vue";
import { Badge } from "@/shared/ui/badge";
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import TableRowActions from "@/shared/ui/custom/components/TableRowActions.vue";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/shared/ui/pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableEmpty,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/ui/table";
export default {
  name: "BenefitTable",
  components: {
    BaseTabs,
    TableFooterWrapper,
    Search,
    Input,
    Button,
    TableRowActions,
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationNext,
    PaginationPrevious,
    Table,
    TableBody,
    TableCell,
    TableEmpty,
    TableHead,
    TableHeader,
    TableRow,
    Badge,
    Popover,
    PopoverTrigger,
    PopoverContent,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      filters: { codes__contains: "", page: 1, size: 20 },
      pageSizes: [1, 5, 10, 20],

      references: [],
      activeTab: "benefit_list",
    };
  },
  computed: {
    actions() {
      const list = [];
      if (this.$store.getters.has_access("TUD")) {
        list.push({
          label: this.$t("Редактировать"),
          type: "default",
          action: "edit",
          icon: "huge-pen2",
        });
      }
      if (this.$store.getters.has_access("TDD")) {
        list.push({
          label: this.$t("Удалить"),
          type: "danger",
          action: "remove",
          icon: "huge-danger",
        });
      }
      list.push({
        label: this.$t("Просмотр льгот"),
        type: "default",
        action: "view",
        icon: "huge-eye",
        isLast: true,
      });
      return list;
    },
    canCreateBenefit() {
      return this.$store.getters.has_access("TCD");
    },
    columns() {
      return [
        { label: "Статус", prop: "is_active", minWidth: 150 },
        { label: "Стоимость скидки ", prop: "discount_value", minWidth: 150 },
      ];
    },
    tabs() {
      const tabs = {};
      if (this.$store.getters.has_access("TVD")) {
        tabs.tariff_list = { label: this.$t("Тарифы для НД") };
        tabs.benefit_list = { label: this.$t("Льготы") };
      }
      if (this.$store.getters.has_access("MVD")) {
        tabs.mrp_list = { label: this.$t("МРП") };
      }
      return tabs;
    },
  },
  watch: {
    filters: { handler: "getTariffPreferentialList", deep: true },
  },
  mounted() {
    this.getTariffPreferentialList();
  },
  methods: {
    async getTariffPreferentialList() {
      this.loading = true;
      try {
        const params = {
          size: this.filters.size,
          page: this.filters.page,
          ...(this.filters.codes__contains
            ? {
                codes__contains: this.filters.codes__contains
                  .trim()
                  .toLowerCase(),
              }
            : {}),
        };
        const data = await getTariffPreferentialList(params);
        if (data?.success && data.payload) {
          this.total = data.payload.total;
          this.filters.size = data.payload.size;
          this.filters.page = data.payload.page;
          this.list = data.payload.items || [];

          const all_codes = data.payload.items
            .map((item) => item.codes)
            .filter((code) => code != null)
            .flat();

          const codes = [...new Set([...all_codes])];
          if (codes.length) {
            await this.loadReferences(codes);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async loadReferences(codes) {
      const data = await getReferenceListByCodes({ codes });
      if (data?.success) {
        this.references = data.payload?.items || [];
      }
    },
    handlePageChange(page) {
      this.filters.page = page;
    },
    goToCreate() {
      this.$router.push({ name: "benefit_new", params: { id: "new" } });
    },
    dateFormat(date) {
      if (!date) return this.$t("Не указано");
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
    async handleActions(item) {
      switch (item.action) {
        case "edit":
          this.$router.push({
            name: "benefit_item",
            params: { id: item.uuid },
          });
          break;
        case "view":
          this.$router.push({
            name: "benefit_item_view",
            params: { id: item.uuid },
          });
          break;
        case "remove":
          await this.removeTariffPreferential(item.uuid);
          break;
      }
    },
    async removeTariffPreferential(id) {
      const data = await removeTariffPreferential(id);
      if (data?.success) await this.getTariffPreferentialList();
    },
    handleRowClick(row) {
      this.$router.push({
        name: "benefit_item_view",
        params: { id: row.id },
      });
    },
    search() {
      this.filters.page = 1;
    },
    renderCell(row, column) {
      if (column.type === "codes") {
        return row?.codes?.length ? `+${row.codes.length}` : "";
      }
      if (column.prop === "is_active") {
        return row.is_active ? this.$t("Активный") : this.$t("Неактивный");
      }

      if (column.prop === "discount_value") {
        return `${this.getNumberValue(row.discount_value)} %`;
      }

      return row[column.prop];
    },
    getReferenceLabel(code) {
      if (!code) return "";
      const reference = this.references.find((item) => item.code === code);
      return reference?.name || "";
    },
    changeTab(tab) {
      this.$router.push({
        name: tab,
      });
    },
    getNumberValue(value) {
      return Number(value || 0);
    },
  },
};
</script>

<template>
  <div class="wrapper-page">
    <div class="flex flex-col h-full w-full gap-8">
      <BaseTabs
        :tabs="tabs"
        :active-tab="activeTab"
        @change:tab="changeTab"
        class="pb-6"
      ></BaseTabs>
      <div class="flex justify-between gap-5">
        <div class="relative" style="width: 320px">
          <Search
            class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground"
          />
          <Input
            v-model="filters.codes__contains"
            :placeholder="$t('Поиск по льготам')"
            class="pl-9"
            @input="search"
          />
        </div>

        <Button v-if="canCreateBenefit" variant="default" @click="goToCreate">
          {{ $t("Создать льгот") }} +
        </Button>
      </div>

      <div class="table-area">
        <div class="h-full overflow-auto">
          <Table :loading="loading" :scroll-reset-key="filters.page">
            <TableHeader>
              <TableRow>
                <TableHead class="w-[68px]"></TableHead>
                <TableHead class="min-w-[300px]">{{
                  $t("Категория нотариального действия")
                }}</TableHead>
                <TableHead class="min-w-[330px]">{{
                  $t("Название льгот")
                }}</TableHead>
                <TableHead
                  v-for="col in columns"
                  :key="col.prop"
                  :class="col.minWidth ? `min-w-[${col.minWidth}px]` : ''"
                  >{{ $t(col.label) }}</TableHead
                >
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableEmpty
                v-if="!loading && !list.length"
                :colspan="3 + columns.length"
              >
                {{ $t("Нет данных") }}
              </TableEmpty>
              <TableRow
                v-for="row in list"
                :key="row.id"
                class="cursor-pointer"
                @click="handleRowClick(row)"
              >
                <TableCell>
                  <TableRowActions
                    :actions="actions"
                    @action="
                      (item) =>
                        handleActions({ action: item.action, uuid: row.id })
                    "
                  />
                </TableCell>
                <TableCell>
                  <div class="flex gap-2">
                    <template v-if="row.codes?.length">
                      <div>
                        {{ getReferenceLabel(row.codes[0]) }}
                      </div>

                      <Popover v-if="row.codes.length > 1">
                        <PopoverTrigger as-child>
                          <div class="trigger" @click.stop>
                            <Badge variant="secondary">
                              +{{ row.codes.length - 1 }}
                            </Badge>
                          </div>
                        </PopoverTrigger>
                        <PopoverContent class="w-[472px] p-0">
                          <ul class="content">
                            <li
                              v-for="option in row.codes"
                              :key="option"
                              class="popover-items"
                            >
                              {{ getReferenceLabel(option) }}
                            </li>
                          </ul>
                        </PopoverContent>
                      </Popover>
                    </template>
                    <template v-else>
                      {{ $t("Не указано") }}
                    </template>
                  </div>
                </TableCell>
                <TableCell>{{ row.name }}</TableCell>
                <TableCell v-for="col in columns" :key="col.prop">
                  {{ renderCell(row, col) }}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <TableFooterWrapper
          :total="total"
          v-model:pageSize="filters.size"
          v-model:currentPage="filters.page"
          :pageSizes="[1, 5, 10, 20]"
          :page-size="filters.size"
        >
          <template #pagination>
            <Pagination
              v-if="total > filters.size"
              :total="total"
              :items-per-page="filters.size"
              :page="filters.page"
              :sibling-count="1"
              show-edges
              :disabled="loading"
              @update:page="handlePageChange"
            >
              <PaginationContent v-slot="{ items }">
                <PaginationPrevious />
                <template v-for="(item, index) in items" :key="index">
                  <PaginationItem
                    v-if="item.type === 'page'"
                    :value="item.value"
                    :is-active="item.value === filters.page"
                  />
                  <PaginationEllipsis v-else />
                </template>
                <PaginationNext />
              </PaginationContent>
            </Pagination>
          </template>
        </TableFooterWrapper>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
.next {
  @apply gap-4 border border-border;
  display: flex;
  padding: 4px 4px 4px 8px;
  align-items: center;
  justify-content: center;
  height: 32px;
  border-radius: 8px;
  background-color: hsl(var(--muted));
}
.arrow-right {
  @apply border border-border;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px !important;

  height: 24px;
  border-radius: 4px;
  background-color: hsl(var(--card));

  svg {
    width: 12px;
    height: 12px;
  }
}

.trigger {
  @apply inline-flex items-center gap-1 cursor-pointer select-none;
}
.content {
  @apply p-2 space-y-2 rounded-xl bg-card flex flex-col  overflow-y-auto;
  max-height: 400px !important;
}
.popover-items {
  @apply flex justify-between items-center px-3 py-1 text-muted-foreground text-sm;
}
</style>
